window.addEventListener('load', (event) => {

    // set variables
    var body = document.querySelector("body");
    var wrapper = document.querySelector("#page-wrapper");
    var drawer = document.querySelector('#mobile-nav-tray');
    var button = document.querySelector('#mobile-nav-btn');
    var windowWidth = document.body.clientWidth;

    // toggle menu function
    var toggleDrawer = function(){
        body.classList.toggle('mobile-nav-open');
        wrapper.classList.toggle('active');
        drawer.classList.toggle('active');
        button.classList.toggle('toggled');  
    }

    // open/close drawer using menu button
    button.addEventListener("click",function(){
        toggleDrawer();
    }, false); 

    // close drawer when clicking off menu
    wrapper.addEventListener("click",function(){
        if (wrapper.classList.contains('active')) {
            toggleDrawer();
        }
    }, false);

    // close drawer if window is resized
    window.addEventListener("resize",function(){
        if(document.body.clientWidth !== windowWidth){
            if (wrapper.classList.contains('active')) {
                toggleDrawer();
            }
        }
        windowWidth = document.body.clientWidth;
    });
});